import React, { Fragment } from "react";
import PropTypes from "prop-types";

import Box from "@tds/core-box";
import Text from "@tds/core-text";
import EN from '../../../EN.json';
import FR from '../../../FR.json';
import { useLocaleContext } from '../../context/LocaleContext';
import { Button } from "../../design/css";

const DefectSummaryHeader = ({
    reportedOn,
    webForm,
    priority,
    status,
    assignee,
    setAssigneeModal,
    isAdmin
}) => {
    const locale = useLocaleContext();
    const {
        DEFECT_MANAGEMENT: { DEFECT_TABLE: { REPORTED_ON, WEBFORM, PRIORITY, STATUS, ASSIGNEE } = {} } = {}
    } = locale === 'en-US' ? EN : FR;

    const getButton = (onClick, label, isDisabled) => (
        <Button onClick={onClick} disabled={isDisabled}>
            {label}
        </Button>
    );

    return (
        <Fragment>
            <Box pb={12}>
                <Text bold color="#4B286D">
                    {REPORTED_ON}:{' '}
                </Text>
                <Text>{reportedOn}</Text>
            </Box>
            <Box pb={12}>
                <Text bold color="#4B286D">
                    {WEBFORM}:{' '}
                </Text>
                <Text>{webForm}</Text>
            </Box>
            <Box pb={12}>
                <Text bold color="#4B286D">
                    {PRIORITY}:{' '}
                </Text>
                <Text>{priority} </Text>
            </Box>
            <Box>
                <Text bold color="#4B286D">
                    {STATUS}:{' '}
                </Text>
                <Text>{status} </Text>
            </Box>
            {isAdmin &&
                <Box>
                    <Text bold color="#4B286D">
                        {ASSIGNEE}:{' '}
                    </Text>
                    {getButton(
                        () => setAssigneeModal(true),
                        (assignee && assignee.length > 0 && assignee[0].label) ? `[ ${assignee[0].label.toString().toLowerCase()} ]` : '[ assign defect ]'
                    )}
                </Box>
            }
        </Fragment>
    );
};

DefectSummaryHeader.prototype = {
    reportedOn: PropTypes.string.isRequired,
    webForm: PropTypes.string.isRequired,
    priority: PropTypes.string.isRequired,
    status: PropTypes.string.isRequired
};

export default DefectSummaryHeader;
